var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        _setup.Button,
        {
          staticClass: "px-2 h-100 rounded-0",
          attrs: { title: "Show help" },
          nativeOn: {
            click: function ($event) {
              _setup.showOffcanvas = true
            },
          },
        },
        [_c(_setup.GeminiIcon)],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "offcanvas offcanvas-end w-75",
          class: { show: _setup.showOffcanvas },
          style: { visibility: _setup.showOffcanvas ? "visible" : "hidden" },
          attrs: { tabindex: "-1" },
        },
        [
          _c(
            "div",
            { staticClass: "offcanvas-header border-bottom bg-white" },
            [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c(
                  "svg",
                  {
                    staticClass: "me-2",
                    attrs: {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M12 0L14.59 7.41L22 10L14.59 12.59L12 20L9.41 12.59L2 10L9.41 7.41L12 0Z",
                        fill: "url(#geminiGradient)",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "defs",
                      [
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "geminiGradient",
                              x1: "2",
                              y1: "2",
                              x2: "22",
                              y2: "20",
                            },
                          },
                          [
                            _c("stop", { attrs: { "stop-color": "#4285F4" } }),
                            _vm._v(" "),
                            _c("stop", {
                              attrs: { offset: "1", "stop-color": "#9b72cb" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("h5", { staticClass: "offcanvas-title fw-bold" }, [
                  _vm._v("Gemini Studio"),
                ]),
              ]),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn-close",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _setup.showOffcanvas = false
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "offcanvas-body p-0 d-flex flex-column flex-md-row",
            },
            [
              _c(
                "aside",
                {
                  staticClass:
                    "bg-light border-end d-flex flex-column p-3 col-md-3",
                },
                [
                  _c(
                    "h6",
                    {
                      staticClass:
                        "text-uppercase small fw-bold text-muted mb-3",
                    },
                    [_vm._v("Activity History")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex-grow-1 overflow-auto" },
                    _vm._l(_setup.historyLogs, function (log) {
                      return _c(
                        "div",
                        {
                          key: log.id,
                          staticClass:
                            "mb-3 p-2 bg-white rounded border-sm shadow-sm",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-start",
                            },
                            [
                              _c("small", { staticClass: "fw-bold d-block" }, [
                                _vm._v(_vm._s(log.action)),
                              ]),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "bi bi-check-circle-fill text-success small",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "small",
                            {
                              staticClass: "text-muted",
                              staticStyle: { "font-size": "0.75rem" },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(log.timestamp) +
                                  " • " +
                                  _vm._s(log.tokens.toLocaleString()) +
                                  " tokens\n                        "
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "border-top pt-3 mt-3" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center mb-1",
                      },
                      [
                        _c("span", { staticClass: "small fw-bold" }, [
                          _vm._v("Daily AI Credits"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "small",
                            class: _setup.isOverLimit
                              ? "text-danger"
                              : "text-primary",
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_setup.dailyUsed.toLocaleString()) +
                                " / " +
                                _vm._s(_setup.dailyLimit.toLocaleString()) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "progress",
                        staticStyle: { height: "8px" },
                      },
                      [
                        _c("div", {
                          staticClass: "progress-bar",
                          class: _setup.isOverLimit
                            ? "bg-danger"
                            : "bg-primary",
                          style: { width: _setup.usagePercentage + "%" },
                          attrs: { role: "progressbar" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _setup.isOverLimit
                      ? _c(
                          "p",
                          { staticClass: "text-danger small mt-2 mb-0" },
                          [
                            _c("i", {
                              staticClass: "bi bi-exclamation-triangle",
                            }),
                            _vm._v(
                              " Daily limit reached.\n                    "
                            ),
                          ]
                        )
                      : _c("p", { staticClass: "text-muted small mt-2 mb-0" }, [
                          _vm._v("Resets at midnight"),
                        ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("main", { staticClass: "flex-grow-1 p-4 position-relative" }, [
                _setup.isOverLimit
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "position-absolute w-100 h-100 top-0 start-0 d-flex align-items-center justify-content-center bg-white bg-opacity-75",
                        staticStyle: { "z-index": "10" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-center p-5 shadow rounded bg-white border",
                          },
                          [
                            _c("i", {
                              staticClass: "bi bi-lock text-muted display-4",
                            }),
                            _vm._v(" "),
                            _c("h3", [_vm._v("Daily Limit Reached")]),
                            _vm._v(" "),
                            _vm._m(0),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-secondary",
                                on: {
                                  click: function ($event) {
                                    _setup.showOffcanvas = false
                                  },
                                },
                              },
                              [_vm._v("Close Studio\n                        ")]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex align-items-center mb-4" }, [
                  _c(
                    "div",
                    { staticClass: "p-2 bg-light rounded-circle me-3" },
                    [
                      _c("i", {
                        staticClass: "text-primary fs-4",
                        class: _setup.tableIcon,
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v("Working on " + _vm._s(_vm.activeTable)),
                    ]),
                    _vm._v(" "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v("AI context is synced to your current view"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "mb-5" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row g-2" },
                    [
                      _vm._l(
                        _setup.contextualPrompts,
                        function (prompt, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "col-md-6 col-lg-4" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "card h-100 prompt-card border-dashed",
                                  attrs: { role: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _setup.usePrompt(prompt)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card-body p-2 d-flex align-items-center",
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "bi bi-plus-circle text-muted me-2",
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "small text-dark" },
                                        [_vm._v(_vm._s(prompt))]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      _vm._v(" "),
                      _setup.contextualPrompts.length === 0
                        ? _c("div", { staticClass: "col-12" }, [
                            _c(
                              "p",
                              { staticClass: "text-muted small italic" },
                              [
                                _vm._v(
                                  "Select a table to see specialized AI tools."
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _vm._m(2),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _setup.showOffcanvas
        ? _c("div", {
            staticClass: "offcanvas-backdrop fade show",
            on: {
              click: function ($event) {
                _setup.showOffcanvas = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "text-muted" }, [
      _vm._v("You've used your allotted AI credits for today."),
      _c("br"),
      _vm._v(
        "Come back tomorrow\n                            or contact your admin."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "h6",
      { staticClass: "text-uppercase small fw-bold text-secondary mb-3" },
      [
        _c("i", { staticClass: "bi bi-lightbulb me-1" }),
        _vm._v(" Suggested Prompts\n                    "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("section", [
      _c(
        "h6",
        { staticClass: "text-uppercase small fw-bold text-secondary mb-3" },
        [_vm._v("Available Tools")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }